import { getOperationName } from '@apollo/client/utilities'
import { useToggle } from 'ahooks'
import { Button } from 'antd'
import Modal from 'antd/lib/modal/Modal'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { GetFeedsRecommendedDocument, useSetBannerMutation } from '@/generated/graphql'

import { BannerImages } from './banner-images.component'
import s from './banner-images.module.less'

export const BannerImageModal: React.FC = ({ children, ...props }) => {
  const displayCount = 6
  const { t } = useTranslation()
  const [visible, { toggle }] = useToggle()
  const [displays, setDisplays] = React.useState<{ bannerId: number; link: string }[]>(
    Array.from({ length: displayCount }, () => ({ bannerId: 0, link: '' }))
  )
  const [setBanner] = useSetBannerMutation({
    refetchQueries: [getOperationName(GetFeedsRecommendedDocument)!],
  })

  children = React.cloneElement(children as any, {
    ...props,
    onClick: toggle,
  })

  const isValid = React.useMemo(() => {
    return displays.filter((display) => display.bannerId !== 0).every((display) => !!display.link)
  }, [displays])

  const onOK = () => {
    setBanner({
      variables: {
        input: displays
          .map((display, index) => ({ bannerId: display.bannerId, link: display.link, index }))
          .filter((display) => display.bannerId !== 0),
      },
    })
    toggle()
  }

  const footer = (
    <div className={s.footer}>
      {!isValid && <span>{t('banner.inputWarning')}</span>}
      <Button onClick={() => toggle()}>{t('banner.cancel')}</Button>
      <Button onClick={() => onOK()} disabled={!isValid} type='primary'>
        {t('banner.save')}
      </Button>
    </div>
  )

  return (
    <>
      {children}
      <Modal width={1400} centered visible={visible} closable={false} footer={footer} destroyOnClose={true}>
        <BannerImages displays={displays} setDisplays={setDisplays} />
      </Modal>
    </>
  )
}
